import { useContext, useState } from "react";
import { RawTextArea } from "./RawTextArea";
import { FormContext } from "./Form";
import { InferType, ObjectSchema } from "yup";
import { FormState } from "./Form.types";
import { isRequired } from "./utils";

type TextAreaProps = {
    name: string;
    label: string;
    parent?: string;
    index?: number;
    placeholder?: string;
};

export function TextArea<T extends ObjectSchema<any>>({
    parent = "",
    ...props
}: TextAreaProps) {
    const [touched, setTouched] = useState(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = useContext(FormContext) as FormState<T> | undefined;

    if (!form) return null;

    const error = form.errors?.[name] || "";
    const showError =
        touched && error && !error.toLowerCase().includes("required");

    return (
        <RawTextArea
            {...props}
            name={name}
            placeholder={props.placeholder}
            required={isRequired(form.schema, name)}
            onChange={(e) => {
                setTouched(true);
                form.updateValue(name as InferType<T>, e.target.value);
            }}
            onBlur={() => setTouched(true)}
            value={form.values[name] || ""}
            errorMessage={showError ? form.errors?.[name] : undefined}
            showErrorRing={Boolean(touched && error)}
        />
    );
}
